<div class="main-card mb-3 card">
  <!-- <div class="card-header font-weight-B fs-1r">All Vehicles</div>  -->

  <div class="main-card mb-3 card">
    <div class="card-header d-flex justify-content-between align-items-center">
      <span class="font-weight-bold fs-1r">Above 4 ton Vehicles</span>
      <button class="btn btn-primary" (click)="addEditVehicleComp.open()">
        + Add Vehicle
      </button>
    </div>
  </div>

  <div class="table-responsive">
    <table
      class="align-middle mb-0 table table-borderless table-striped table-hover"
      id="excel-table"
    >
      <thead>
        <tr>
          <th>Truck Type</th>
          <th>Image</th>
          <th>Length</th>
          <th>Breadth</th>
          <th>Height</th>
          <th>Tyres</th>
          <th class="text-end">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of allVehicleList">
          <td class="w-16">
            <div class="widget-content p-0">
              <div class="widget-content-wrapper">
                <div class="widget-content-left flex2">
                  <div class="widget-heading">{{ data.truckType }}</div>
                </div>
              </div>
            </div>
          </td>

          <td class="w-17">
            <div class="widget-content p-0">
              <div class="widget-content-wrapper">
                <div class="widget-content-left flex2">
                  <img
                    [src]="data.image"
                    alt="Image"
                    style="width: 50px; height: 40px"
                  />
                </div>
              </div>
            </div>
          </td>
          <td class="w-17">
            <div class="widget-content p-0">
              <div class="widget-content-wrapper">
                <div class="widget-content-left flex2">
                  <div class="widget-heading">{{ data.vehicleLength }} ft</div>
                </div>
              </div>
            </div>
          </td>
          <td class="w-17">
            <div class="widget-content p-0">
              <div class="widget-content-wrapper">
                <div class="widget-content-left flex2">
                  <div class="widget-heading">{{ data.vehicleBreadth }} ft</div>
                </div>
              </div>
            </div>
          </td>
          <td class="w-17">
            <div class="widget-content p-0">
              <div class="widget-content-wrapper">
                <div class="widget-content-left flex2">
                  <div class="widget-heading">{{ data.vehicleHeight }} ft</div>
                </div>
              </div>
            </div>
          </td>
          <td class="w-17">
            <div class="widget-content p-0">
              <div class="widget-content-wrapper">
                <div class="widget-content-left flex2">
                  <div class="widget-heading">{{ data.truckTyres }}</div>
                </div>
              </div>
            </div>
          </td>

          <td class="text-end">
            <div class="dropdown">
              <button
                class="btn btn-info dropdown-toggle"
                type="button"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Action
              </button>
              <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                <li>
                  <a
                    class="dropdown-item"
                    (click)="viewVehicle(data); viewVehicleComp.open(data)"
                    >View Details <i class="fa fa-eye"></i
                  ></a>
                </li>
                <li>
                  <a
                    class="dropdown-item"
                    (click)="editVehicle(data); addEditVehicleComp.open()"
                    >Edit <i class="fa fa-pencil"></i
                  ></a>
                </li>
                <li>
                  <a class="dropdown-item" (click)="deleteVehi(data)"
                    >Delete <i class="fa fa-trash"></i
                  ></a>
                </li>
              </ul>
            </div>
          </td>
        </tr>
      </tbody>
      <div *ngIf="allVehicleList?.length == 0" class="text-center mt-5 mb-5">
        <span class="text-danger">Data Not found</span>
      </div>
    </table>
  </div>

  <!-- Reference the child component -->
  <app-add-and-edit-vehicle
    #addEditVehicleComp
    [vehicleData]="selectedVehicle"
    (formSubmitted)="handleFormSubmit($event)"
  ></app-add-and-edit-vehicle>

  <app-view-vehicle
    #viewVehicleComp
    [vehicleData]="selectedVehicle"
  ></app-view-vehicle>
</div>
